import { call, put } from 'redux-saga/effects';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';
import { setAnalyticTeamMember } from '../../../../state/analytic/analyticTeamMemberSlice';

export function* fetchTeamMemberSaga(action) {
  const { teamId } = action.payload || {};
  if (!teamId) return;
  try {
    const { data } = yield call(
      [backendClient, backendClient.get],
      `teams/${encodeURIComponent(teamId)}/members`
    );
    yield put(setAnalyticTeamMember({ teamId, members: data || [] }));
  } catch (err) {
    const status = err?.response?.status;
    bugsnagClient.notify(err);
    console.error('Failed to fetch analytic team member', status, err?.message);
  }
}